(() => {
  let loading;

  function loadCalendly() {
    if (window.Calendly?.initPopupWidget) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://assets.calendly.com/assets/external/widget.css';
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      let cssReady = false;
      let scriptReady = false;
      const timeout = setTimeout(() => fail(), 15000);
      function fail() {
        clearTimeout(timeout);
        stylesheet.remove();
        script.remove();
        loading = null;
        reject(new Error('Calendly could not be loaded'));
      }
      script.onerror = fail;
      stylesheet.onerror = fail;
      function ready() {
        if (!cssReady || !scriptReady) return;
        clearTimeout(timeout);
        if (window.Calendly?.initPopupWidget) resolve();
        else fail();
      }
      stylesheet.onload = () => { cssReady = true; ready(); };
      script.onload = () => { scriptReady = true; ready(); };
      document.head.append(stylesheet, script);
    });
    return loading;
  }

  function positionCloseButton() {
    let attempts = 0;
    const timer = setInterval(() => {
      const button = document.querySelector('.calendly-popup-close');
      const content = document.querySelector('.calendly-popup-content');
      if (button && content) {
        if (button.parentElement !== content) content.appendChild(button);
        clearInterval(timer);
      } else if (++attempts >= 30) clearInterval(timer);
    }, 100);
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, document.baseURI);
    if (url.hostname !== 'calendly.com' && !url.hostname.endsWith('.calendly.com')) return;
    event.preventDefault();
    try {
      await loadCalendly();
      window.Calendly.initPopupWidget({ url: link.href });
      positionCloseButton();
    } catch (error) {
      window.location.assign(link.href);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') window.Calendly?.closePopupWidget?.();
  });
})();
